import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { CanvasService } from '../../services/canvas/canvas.service';
import { ResourceData } from '../../elements/resource/resource.types';
import { ShapeService } from '../../element-editor/shape/shape.service';
import { IdToIRI, IRIToId } from '../../util/iri';
import { AnimationService } from '../animation/animation.service';
import { AnimationFrameObject } from '../animation/frame/animation-frame-object';
import { MainAnimationFrameObject } from '../animation/frame/main-animation-frame-object';
import { setCurrentAnimationId } from '../animation/store/animation.actions';
import { currentTime } from '../animation/store/animation.selector';
import {
  selectPreviewShapeLoading,
  selectSlides,
} from '../store/selector/editor.selector';
import { map } from 'rxjs/operators';
import { selectRootFilesBySceneIndex } from '../../projects/project.selector';

@Component({
  selector: 'nw-slide-viewer',
  templateUrl: './slide-viewer.component.html',
  styleUrls: ['./slide-viewer.component.scss'],
})
export class SlideViewerComponent implements OnInit {
  fastRewindHover = false;
  playArrowHover = false;
  fastForwardHover = false;

  scenes$: Observable<ResourceData[]>;
  get currentSceneId() {
    return this.cs.currentAnimationID;
  }
  // get timePinPosition() {
  //   return this.animationService.currentTimeInSec * 96;
  // }

  currentTime$: Observable<number>;
  sceneIndex = 0;
  sceneIndexes: Record<string, number> = {};
  scenes: ResourceData[] = [];
  imgLoaded: { [iri: string]: boolean } = {};
  imgError: { [iri: string]: boolean } = {};

  addIconSize = 12;
  addLastIconSize = 12;

  addSceneIndex = undefined;

  get thumbnailDataUrl() {
    return this.cs.thumbnailDataUrl;
  }

  get rootThumbnail() {
    return this.getThumbnailDataUrl(IdToIRI(this.cs.currentRootFileID));
  }

  isPreviewShapeLoading$: Observable<boolean>;

  constructor(
    private store: Store,
    private cs: CanvasService,
    private shapeService: ShapeService,
    private readonly animationService: AnimationService,
    private cdr: ChangeDetectorRef,
  ) {
    // -- // -- //
    this.currentTime$ = this.store
      .select(currentTime)
      // .pipe(map((time: number) => (118 * time) / 60));
      .pipe(map((time: number) => (106 * time) / 60));
    this.isPreviewShapeLoading$ = this.store.select(selectPreviewShapeLoading);
    // this.scenes$ = this.cs.store.select(selectRootFilesBySceneIndex);
    this.scenes$ = this.cs.store.select(selectSlides);
  }

  get frames() {
    if (!this.animationService.mainFrame) {
      return [];
    }

    const frames = [] as AnimationFrameObject[];
    let frame = this.animationService.mainFrame
      .firstFrame as AnimationFrameObject;
    while (frame) {
      frames.push(frame);
      frame = frame.next;
    }
    return frames;
  }

  currentFrame: AnimationFrameObject = null;

  goToFrame(frame: AnimationFrameObject) {
    this.currentFrame = frame;
    if (frame && frame.select) {
      frame.select();
      this.shapeService.store.dispatch(
        setCurrentAnimationId({ id: frame.globalID || frame.id }),
      );
    }
  }

  goToNextFrame() {
    const lastFrame = this.frames[this.frames.length - 1];
    if (lastFrame) {
      this.goToFrame(lastFrame);
    }
  }

  goToPrevFrame() {
    this.cs.previewShape.resetBaseState();
  }

  async playFrames() {
    this.animationService.playAnimations();
  }

  isActive(frame: AnimationFrameObject) {
    return frame.id == this.cs.currentAnimationID;
  }

  timeout: NodeJS.Timeout;

  mouseOver(index: number) {
    return;
    // if (this.timeout) {
    //   clearTimeout(this.timeout);
    // }

    this.addSceneIndex = undefined;

    // this.timeout = setTimeout(() => {
    if (index == this.scenes.length - 1) {
      this.addSceneIndex = undefined;
      return;
    }
    // console.log('add-scene-index', index);
    this.addSceneIndex = index;
    // .. // .. // .. //
  }

  mouseOut() {
    return;
    console.log('mouse out');
    this.addSceneIndex = undefined;
  }

  getThumbnailDataUrl(id: string) {
    // return `https://s3.eu-central-1.amazonaws.com/nowords-vlog.illustrations/${this.cs.currentFileID}_${id}_thumbnail.png`;
    return this.cs.animationThumbnails[id];
  }

  lastSceneIndex = 0;
  ngOnInit() {
    this.cs.generalEventSubscribe('thumbnails-loaded', () => {
      this.cdr.detectChanges();
    });
    this.cs.generalEventSubscribe('animation-finished', () => {
      this.cdr.detectChanges();
    });
  }

  addNewScene(frame?: AnimationFrameObject) {
    if (!frame) {
      if (!this.frames?.length) {
        const mainFrame = this.cs.addFirstFrame();
        this.goToFrame(mainFrame.firstFrame);
      } else {
        const lastFrame = this.frames[this.frames.length - 1];
        let newFrame: AnimationFrameObject;
        if (lastFrame instanceof MainAnimationFrameObject) {
          newFrame = lastFrame.firstFrame.insertNext();
        } else {
          newFrame = lastFrame.insertNext();
        }
        lastFrame.save();
        this.cs.previewShape.updateAnimationMap();
        newFrame.select();
      }
      return;
    }
    // const IRI = this.shapeService.getNewIRI();
    // const ID = IRIToId(IRI);
    // if (!scene) {
    //   console.log('last-scene-index', this.lastSceneIndex);
    //   this.store.dispatch(
    //     createScene({
    //       IRI,
    //       index: this.lastSceneIndex + 1,
    //       parentFileID: this.cs.currentRootFileID,
    //     }),
    //   );
    //   this.shapeService.navigateToScene(ID);
    //   this.store.dispatch(setCurrentSceneID({ id: ID }));
    //   return;
    // }

    // scene ||= this.scenes[this.scenes.length - 1];

    // const nextScene = this.scenes[this.sceneIndexes?.[scene.IRI] + 1];
    // const index = nextScene
    //   ? (+scene.literals.sceneIndex + +nextScene.literals.sceneIndex) / 2
    //   : +scene.literals.sceneIndex + 1;
    // this.store.dispatch(
    //   createScene({
    //     IRI,
    //     index,
    //     parentFileID: this.cs.currentRootFileID,
    //   }),
    // );
    // this.shapeService.navigateToScene(ID);
  }

  deleteScene(frame: AnimationFrameObject) {
    frame.remove();
    setTimeout(() => {
      // -- // -- //
      console.log('detect-changes', this.frames);
      this.cdr.detectChanges();
    }, 10);
  }

  duplicateScene(IRI: string) {
    // -- // duplicate scene // -- //
  }
  goToFirstScene() {
    this.shapeService.navigateToFile(this.cs.currentRootFileID);
  }

  goToScene(scene: ResourceData) {
    this.shapeService.navigateToAnimation(IRIToId(scene.IRI));
  }
}
